import React, { useEffect } from 'react';
import './Button.css';
type ButtonProps  = {
    onClick: () => void;
    label: string;
    type: 'button' | 'submit' | 'cancel';
    disabled?:boolean;
    height?:string;
    width?:string;
}

const Button: React.FC<ButtonProps> = ({onClick, label,type,disabled,height,width,...props}) => {
    const class_name= type==='button'?'btn btn-primary me-3':type==='submit'? 'button-submit':'button-cancel';
    const disabled_class = disabled?'button-disabled':'';

    return (
        <button onClick={onClick} disabled={disabled} style={{height: height, width:width}} {...props} className={`${class_name} ${disabled_class}`}>{label}</button>
    );
}

export default Button;
